import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { gql } from '@apollo/client'
import { EXCLUSION_PROCEDURE_QUERY } from '../../../graphql.js'
import { Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { handleGraphQLErrors } from '../../../utils'
import '../Custom.css'

const EXCLUSION_PROCEDURE = gql(EXCLUSION_PROCEDURE_QUERY)

export default function ExclusionProcedure() {
  console.log('ExclusionProcedure rendered')

  const [results, setResults] = useState()
  const [spinner, setSpinner] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])

  async function executeProcedure() {
    console.log('ExclusionProcedure.executeProcedure')
    try {
      setSpinner(true)
      const { data, errors } = await window.apolloClient.query({ query: EXCLUSION_PROCEDURE })
      if (data.exclusionProcedure) {
        setResults(data.exclusionProcedure)
      }
      if (errors) {
        setGraphQLErrors(errors)
      }
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    } finally {
      setSpinner(false)
    }
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }

  if (spinner) {
    return <Spinner />
  }

  if (results && results === 'Success') {
    return (
      <Navigate to="/custom/exclusionStatus" />
    )
  } else {
    return (
      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <Button style={{ fontSize: '1.25rem'}} color="primary" onClick={() => executeProcedure()}>Execute Exclusion Procedure Now</Button>
      </div>
    )
  }
}
